import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import store from "store";
import AuthActions from "Redux/AuthRedux";
import { PageLoader } from "./Spinner";

// Storage keys
const AUTH_DATA_KEY = "authData";
const USER_DATA_KEY = "userData";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check localStorage for auth data
    const authData = store.get(AUTH_DATA_KEY);
    const userData = store.get(USER_DATA_KEY);

    if (authData?.token && userData) {
      // Verify token is still valid by calling me endpoint
      dispatch(
        AuthActions.meRequest((resp, err) => {
          setIsLoading(false);
          if (err) {
            // Token invalid, clear auth data
            store.remove(AUTH_DATA_KEY);
            store.remove(USER_DATA_KEY);
            setIsAuthenticated(false);
          } else {
            setIsAuthenticated(true);
          }
        })
      );
    } else {
      setIsLoading(false);
      setIsAuthenticated(false);
    }
  }, [dispatch]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <PageLoader label="Loading your workspace..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
}
